/* eslint-disable react/jsx-pascal-case */
import { useEffect } from "react";
import Router from "@components/Router";
import WS10Theme from "@vfuk/core-theme-ws10";
import { ThemeProvider } from "styled-components";
import { ToastContext } from "@ucchub/ui";
import environment from "environment";
import { Link } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useFeatureFlagsStore } from "@ucchub/ui";
import type { ReactElement } from "react";
import "./global.css";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { isDev } = require("./lib/helpers");

WS10Theme.setCustomRouter(Link as unknown as ReactElement);
WS10Theme.setBaseAssetLocation(
  isDev()
    ? "http://localhost:3000/core/assets/ws10/"
    : environment.portalUrl + "/core/assets/ws10/"
);
const App = () => {
  const setCloudNumbersFlags = useFeatureFlagsStore(
    (state) => state.setCloudNumbersFlags
  );

  useEffect(() => {
    async function fetchFlags() {
      try {
        /**
         * The deployment of feature flags will be changed. Instead of using a single bucket, we will  deploy each environment file to its respective environment.
         *  In the mean time will comment the fetching request to avoid having CORS errors until we get the deployment update done.
         *  */

        //  const response = await fetch(environment.api.cloudNumberFeatureFlags);
        //  const flags = await response.json();

        setCloudNumbersFlags({});
      } catch (error) {
        throw new Error("Feature flags not uploaded " + error);
      }
    }

    fetchFlags();
  }, []);
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={WS10Theme}>
        <WS10Theme.globalStyles />
        <Router />
        <ToastContext />
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default App;
